webpackJsonp([33],{

/***/ 1036:
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(158),
    baseFlatten = __webpack_require__(157),
    copyArray = __webpack_require__(337),
    isArray = __webpack_require__(10);

/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */
function concat() {
  var length = arguments.length;
  if (!length) {
    return [];
  }
  var args = Array(length - 1),
      array = arguments[0],
      index = length;

  while (index--) {
    args[index - 1] = arguments[index];
  }
  return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
}

module.exports = concat;


/***/ }),

/***/ 1359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _concat = __webpack_require__(1036);

var _concat2 = _interopRequireDefault(_concat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-gallery',
  props: {
    nid: [Number, String]
  },
  computed: {
    node: function node() {
      return this.$store.getters.node(this.nid);
    },
    slideshow: function slideshow() {
      if ((0, _isEmpty2.default)(this.node.images)) return [];
      var images = [];
      (0, _forEach2.default)(this.node.images, function (img) {
        if (img.slideshow) {
          images = (0, _concat2.default)(images, img);
        }
      });
      return images;
    }
  }
};

/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".carousel[data-v-d4111042]{margin-top:1rem;margin-bottom:.875rem}", "", {"version":3,"sources":["/app/components/gallery/amp/AmpCarousel.vue"],"names":[],"mappings":"AAgCA,2BACE,gBAAiB,AACjB,qBAAwB,CACzB","file":"AmpCarousel.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.carousel[data-v-d4111042] {\n  margin-top: 1rem;\n  margin-bottom: 0.875rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1630:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1541);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("9358150e", content, true, {});

/***/ }),

/***/ 1697:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1630)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1359),
  /* template */
  __webpack_require__(1786),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d4111042",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1786:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.slideshow.length) ? _c('amp-carousel', {
    staticClass: "carousel",
    attrs: {
      "width": "600",
      "height": "600",
      "layout": "responsive",
      "type": "slides",
      "loop": "",
      "controls": ""
    }
  }, _vm._l((_vm.slideshow), function(val, key) {
    return _c('amp-img', {
      key: key,
      attrs: {
        "src": val.style_600x600,
        "width": "600",
        "height": "600",
        "layout": "responsive"
      }
    })
  })) : _vm._e()
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 33.d99e19e1678a5af235ae.js